document.addEventListener('DOMContentLoaded', () => {
    const { productHandle: handle } = document.body.dataset;
    if (!handle) return;

    const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');

    if (!recentlyViewed.includes(handle)) {
        recentlyViewed.unshift(handle);
        if (recentlyViewed.length > 4) recentlyViewed.pop();
        localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    }
});

class RecentlyViewed extends HTMLElement {
    connectedCallback() {
        this.render();
    }

    async render() {
        const items = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
        if (!items.length) return;

        const htmls = await Promise.all(
            items.map(handle =>
                fetch(`${Shopify.routes.root}products/${handle}?view=card&section_id=product_card_view`)
                    .then(r => r.text())
            )
        );

        const temp = document.createElement('div');
        temp.innerHTML = htmls.join('');
        this.append(...temp.querySelectorAll('product-card'));
    }
}

customElements.define('recently-viewed', RecentlyViewed);